import { useSessionContext } from '@/contexts/session/context';
import type { User } from '@/configs/apis/user';
import ReceiverActions from './components/receiverActions';
import SelfActions from './components/selfActions';
import styles from './index.module.scss';

const FooterActions = ({ info }: { info: Partial<User> }) => {
  const {
    session: { user },
  } = useSessionContext();

  const isMe = useMemo(() => info.userId === user?.userId, [info.userId, user?.userId]);

  return (
    <div className={styles.footerActions}>
      {isMe ? <SelfActions /> : <ReceiverActions />}
    </div>
  );
};

export default FooterActions;
